module.exports = __webpack_public_path__ + "static/media/new-appt.ee36d496.svg";